<app-homegrown-banner />
<app-customers-count />

<footer class="flex flex-col" style="background:#e6e7e8">

  <!-- ── MAIN LINK COLUMNS ── -->
  <div style="max-width:1514px; margin:0 auto; padding:36px 24px 24px">
    <div class="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">

      <!-- NEED HELP -->
      <div>
        <h4 style="font-size:20px; font-weight:700; color:#ed2e30; text-transform:uppercase; margin-bottom:16px">
          Need Help
        </h4>
        <ul style="list-style:none; padding:0; margin:0">
          @for (l of needHelp; track l.label) {
            <li style="margin-bottom:10px">
              <a [routerLink]="l.path" style="font-size:15px; font-weight:600; color:#58595b; text-decoration:none"
                 class="hover:!text-[#ff0000] transition-colors">{{ l.label }}</a>
            </li>
          }
        </ul>
        <div style="margin-top:16px">
          <div style="display:flex; align-items:center; gap:8px; margin-bottom:10px">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#3d4152" stroke-width="1.5">
              <circle cx="12" cy="12" r="10"/>
              <text x="12" y="16" text-anchor="middle" font-size="9" font-weight="700" fill="#3d4152" stroke="none" font-family="Arial">₹</text>
            </svg>
            <span style="font-size:14px; font-weight:600; color:#3d4152">COD Available</span>
          </div>
          <div style="display:flex; align-items:center; gap:8px">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#3d4152" stroke-width="1.5">
              <path stroke-linecap="round" d="M4 12a8 8 0 0 1 14-5.3M20 12a8 8 0 0 1-14 5.3M4 12H1l3-3m0 6l-3-3M20 12h3l-3 3m0-6l3 3"/>
            </svg>
            <span style="font-size:14px; font-weight:600; color:#3d4152">30 Days Easy Returns &amp; Exchanges</span>
          </div>
        </div>
      </div>

      <!-- COMPANY -->
      <div>
        <h4 style="font-size:20px; font-weight:700; color:#ed2e30; text-transform:uppercase; margin-bottom:16px">
          Company
        </h4>
        <ul style="list-style:none; padding:0; margin:0">
          @for (l of company; track l.label) {
            <li style="margin-bottom:10px">
              <a [routerLink]="l.path" style="font-size:15px; font-weight:600; color:#58595b; text-decoration:none"
                 class="hover:!text-[#ff0000] transition-colors">{{ l.label }}</a>
            </li>
          }
        </ul>
      </div>

      <!-- MORE INFO -->
      <div>
        <h4 style="font-size:20px; font-weight:700; color:#ed2e30; text-transform:uppercase; margin-bottom:16px">
          More Info
        </h4>
        <ul style="list-style:none; padding:0; margin:0">
          @for (l of moreInfo; track l.label) {
            <li style="margin-bottom:10px">
              <a [routerLink]="l.path" style="font-size:15px; font-weight:600; color:#58595b; text-decoration:none"
                 class="hover:!text-[#ff0000] transition-colors">{{ l.label }}</a>
            </li>
          }
        </ul>
      </div>

      <!-- STORE NEAR ME -->
      <div>
        <h4 style="font-size:20px; font-weight:700; color:#ed2e30; text-transform:uppercase; margin-bottom:16px">
          Store Near Me
        </h4>
        <ul style="list-style:none; padding:0; margin:0">
          @for (l of stores; track l.label) {
            <li style="margin-bottom:10px">
              <a [routerLink]="l.path" style="font-size:15px; font-weight:600; color:#58595b; text-decoration:none"
                 class="hover:!text-[#ff0000] transition-colors">{{ l.label }}</a>
            </li>
          }
          <li>
            <a routerLink="/stores-near-me" style="font-size:14px; font-weight:700; color:#0073e6; text-decoration:none"
               class="hover:underline">View More</a>
          </li>
        </ul>
      </div>

    </div>
  </div>

  <!-- ── FOLLOW US ── -->
  <div style="border-top:1px solid #d0d0d0; padding:12px 0">
    <div style="max-width:1514px; margin:0 auto; padding:0 24px; display:flex; justify-content:flex-end; align-items:center; gap:10px">
      <span style="font-size:14px; font-weight:600; color:#3d4152">Follow Us:</span>
      <span aria-label="Facebook" style="width:36px; height:36px; border-radius:50%; background:#1877f2; display:flex; align-items:center; justify-content:center">
        <svg width="16" height="16" fill="white" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
      </span>
      <span aria-label="Instagram" style="width:36px; height:36px; border-radius:50%; display:flex; align-items:center; justify-content:center; background:radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%, #d6249f 60%, #285AEB 90%)">
        <svg width="16" height="16" fill="white" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
      </span>
      <span aria-label="Snapchat" style="width:36px; height:36px; border-radius:50%; background:#FFFC00; display:flex; align-items:center; justify-content:center">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="#1a1a1a"><path d="M12.166 3c-3.114 0-5.166 1.333-5.166 3.832 0 .98.38 1.972 1.006 2.57.106.1.123.264.042.382L7.4 11.48a.28.28 0 0 1-.308.113c-1.252-.354-2.5-.246-2.5-.246-.174 0-.316.142-.316.316v.578c0 .174.142.316.316.316h.512c.155 0 .283.114.31.266.185 1.05.915 1.877 1.86 2.207.126.044.192.18.15.306l-.368 1.1a.317.317 0 0 0 .3.418h5.29a.317.317 0 0 0 .3-.418l-.368-1.1a.314.314 0 0 1 .15-.306c.945-.33 1.675-1.157 1.86-2.207a.312.312 0 0 1 .31-.266h.512c.174 0 .316-.142.316-.316v-.578c0-.174-.142-.316-.316-.316 0 0-1.248-.108-2.5.246a.28.28 0 0 1-.308-.113l-.648-1.696a.305.305 0 0 1 .042-.382C16.62 8.804 17 7.812 17 6.832 17 4.333 15.28 3 12.166 3z"/></svg>
      </span>
      <span aria-label="X (Twitter)" style="width:36px; height:36px; border-radius:50%; background:#111; display:flex; align-items:center; justify-content:center">
        <svg width="15" height="15" fill="white" viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
      </span>
    </div>
  </div>

  <!-- ── WHO WE ARE ── -->
  <div style="border-top:1px solid #d0d0d0">
    <div style="max-width:1514px; margin:0 auto; padding:0 24px">
      <button (click)="whoWeAreOpen = !whoWeAreOpen"
        style="width:100%; display:flex; justify-content:space-between; align-items:center; padding:14px 0; background:none; border:none; cursor:pointer">
        <span style="font-size:14px; font-weight:700; color:#ff0000; text-transform:uppercase; letter-spacing:0.5px">Who We Are</span>
        <svg width="18" height="18" fill="none" stroke="#ff0000" stroke-width="2" viewBox="0 0 24 24"
             [style.transform]="whoWeAreOpen ? 'rotate(45deg)' : 'none'" style="transition:transform 0.2s">
          <path stroke-linecap="round" d="M12 5v14M5 12h14"/>
        </svg>
      </button>
      @if (whoWeAreOpen) {
        <p style="font-size:14px; color:#6a6a6a; line-height:1.6; padding-bottom:14px; max-width:760px">
          MMTEES is India's leading online destination for licensed merchandise and fan apparel.
          We bring you the best in pop culture fashion — from Marvel and DC to your favourite TV shows, anime, and more.
          100% authentic. Members always get more.
        </p>
      }
    </div>
  </div>

  <!-- ── PAYMENT & SHIPPING ── -->
  <div style="border-top:1px solid #d0d0d0; padding:12px 0">
    <div style="max-width:1514px; margin:0 auto; padding:0 24px; display:flex; align-items:center; justify-content:space-between; flex-wrap:wrap; gap:10px">
      <div style="display:flex; align-items:center; gap:12px; flex-wrap:wrap">
        <span style="font-size:13px; font-weight:600; color:#3d4152; white-space:nowrap">100% Secure Payment:</span>
        <!-- TSS payment-methods sprite (PhonePe, GPay, Amazon Pay, Mastercard, Mobikwik, Paytm, BHIM, COD) -->
        <img src="https://sava-s3.in-maa-1.linodeobjects.com/mmtees-dev/marketing/misc/payments-icon.png" alt="Accepted payment methods"
             style="height:72px; width:auto; object-fit:contain"/>
      </div>
      <div style="display:flex; align-items:center; gap:14px; flex-wrap:wrap">
        <span style="font-size:13px; font-weight:600; color:#3d4152; white-space:nowrap">Shipping Partners:</span>
        @for (sp of shippingLogos; track sp.alt) {
          <img [src]="sp.src" [alt]="sp.alt" style="height:26px; width:auto; object-fit:contain"/>
        }
      </div>
    </div>
  </div>

  <!-- ── COPYRIGHT ── -->
  <div style="border-top:1px solid #d0d0d0; padding:10px 0; text-align:center">
    <p style="font-size:12px; color:#6a6a6a">© MMTEES 2026-27</p>
  </div>

</footer>
